import useGetSearchColumns from '@/hooks/useGetSearchColumns';
import { useAppSelector } from '@/redux/hooks';
import { getSearchedAndPromotedItems } from '@/redux/modules/search/aggregateResults/searchAggregate.selectors';
import { getSimilarItemIds } from '@/redux/modules/similarItems';

export const useSimilarActiveItems = () => {
    const columns = useGetSearchColumns({ isOnSearchPage: true });

    const searchPageItemIds = useAppSelector((state) => getSearchedAndPromotedItems(state, columns));

    const firstItemId = searchPageItemIds[0];

    const similarActiveItemIds = useAppSelector((state) => (firstItemId ? getSimilarItemIds(state, firstItemId) : []));
    return similarActiveItemIds;
};
